import React, { useCallback, useEffect, useLayoutEffect, useMemo, useState } from 'react';
import ForwardIcon from '@material-ui/icons/NavigateNext';
import BackIcon from '@material-ui/icons/NavigateBefore';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import throttle from 'lodash/throttle';
const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
    },
    viewport: {
        display: 'flex',
        overflowX: 'hidden',
        flex: '1',
    },
    movementButton: {
        color: '#cfcfcf',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        '& button': {
            height: '100%',
            pointerEvents: 'auto',
            display: 'flex',
            alignItems: 'center',
            borderRadius: 0,
            minWidth: 0,
        },
        '& button:hover': {
            background: 'transparent',
        },
    },
    forwardButton: {},
    backButton: {},
}));
export default function HorizontalList(props) {
    const classes = useStyles();
    const [viewportRef, setViewportRef] = useState(null);
    const { leftScrollNeeded, rightScrollNeeded } = useScrollNeededCheck(viewportRef);
    const scrollNeeded = useMemo(() => leftScrollNeeded || rightScrollNeeded, [leftScrollNeeded, rightScrollNeeded]);
    const handleBackButtonClick = useCallback(() => {
        scrollViewport(viewportRef, 'back');
    }, [viewportRef]);
    const handleForwardButtonClick = useCallback(() => {
        scrollViewport(viewportRef, 'forward');
    }, [viewportRef]);
    return (React.createElement("div", { className: classes.root },
        scrollNeeded ?
            React.createElement("div", { className: `${classes.movementButton} ${classes.backButton}` },
                React.createElement(Button, { color: "primary", onClick: handleBackButtonClick, variant: "text", size: "small", disabled: !leftScrollNeeded, disableRipple: true },
                    React.createElement(BackIcon, { fontSize: "large", viewBox: "4 0 16 24" }))) : null,
        React.createElement("div", { className: classes.viewport, ref: setViewportRef }, props.children),
        scrollNeeded ?
            React.createElement("div", { className: `${classes.movementButton} ${classes.forwardButton}` },
                React.createElement(Button, { color: "primary", onClick: handleForwardButtonClick, variant: "text", size: "small", disabled: !rightScrollNeeded, disableRipple: true },
                    React.createElement(ForwardIcon, { fontSize: "large", viewBox: "4 0 16 24" }))) : null));
}
/**
 * Хук проверяющий необходим ли скролл для указанного элемента.
 */
function useScrollNeededCheck(viewport) {
    const [scrollNeeded, setScrollNeeded] = useState({
        leftScrollNeeded: false,
        rightScrollNeeded: false
    });
    const handler = () => {
        const edges = viewport ? getVisibleEdges(viewport) : [];
        if (!viewport || edges.length != 2) {
            setScrollNeeded({ leftScrollNeeded: false, rightScrollNeeded: false });
            return;
        }
        const [_0, lEdgeIndex, lEdgeRect] = edges[0];
        const [_1, rEdgeIndex, rEdgeRect] = edges[1];
        const viewportRect = viewport.getBoundingClientRect();
        const leftScrollNeeded = lEdgeIndex != 0 || lEdgeRect.x < viewportRect.x;
        const rightScrollNeeded = rEdgeIndex != viewport.children.length - 1 ||
            (rEdgeRect.x + rEdgeRect.width > viewportRect.x + viewportRect.width &&
                Math.abs((rEdgeRect.x + rEdgeRect.width) - (viewportRect.x + viewportRect.width)) >= 1);
        window.GVE = getVisibleEdges;
        console.log({ rEdgeIndex, rEdgeRect, rEdge: rEdgeRect.x + rEdgeRect.width, vpEdge: viewportRect.x + viewportRect.width });
        setScrollNeeded({ leftScrollNeeded, rightScrollNeeded });
    };
    // FIXME: при изменении контента вьюпорта реакции со стороны хука не будет.
    const throttledHandler = useCallback(throttle(handler, 100), [viewport]);
    const throttledScrollHandler = useCallback(throttle(handler, 16), [viewport]);
    useLayoutEffect(() => {
        if (!viewport)
            return;
        handler();
        window.addEventListener('resize', throttledHandler);
        viewport.addEventListener('scroll', throttledScrollHandler);
        return () => {
            window.removeEventListener('resize', throttledHandler);
            viewport === null || viewport === void 0 ? void 0 : viewport.removeEventListener('scroll', throttledScrollHandler);
        };
    }, [throttledHandler, throttledScrollHandler]);
    useEffect(() => {
        setTimeout(() => handler(), 100);
    }, [viewport]);
    return scrollNeeded;
}
function scrollViewport(viewport, direction) {
    const edges = getVisibleEdges(viewport);
    if (edges.length != 2)
        return;
    const viewportRect = viewport.getBoundingClientRect();
    let offsetX = 0;
    if (direction == 'forward') {
        const [_1, _2, rect] = edges[1];
        offsetX = viewport.scrollLeft + rect.x - viewportRect.x;
    }
    else {
        const [_1, _2, rect] = edges[0];
        offsetX = Math.max(0, viewport.scrollLeft + rect.x + rect.width - viewportRect.x - viewportRect.width);
    }
    viewport.scrollTo({ left: offsetX, top: 0, behavior: 'smooth' });
}
function getVisibleEdges(viewport) {
    const viewRect = viewport.getBoundingClientRect();
    const edges = [];
    let lastVisibleIndex = null;
    let lastVisibleRect = null;
    // Можно ускорить алгоритм для длинных списков путем поиска начального
    // видимого элемента через бинарный поиск?
    for (let i = 0; i < viewport.children.length; ++i) {
        const child = viewport.children[i];
        const childRect = child.getBoundingClientRect();
        const x1 = childRect.x + childRect.width;
        const isVisible = (viewRect.x < childRect.x && childRect.x < viewRect.x + viewRect.width) ||
            (viewRect.x < x1 && x1 < viewRect.x + viewRect.width);
        if (lastVisibleIndex === null && isVisible)
            edges.push([child, i, childRect]);
        if (lastVisibleIndex !== null && !isVisible)
            break;
        if (isVisible) {
            lastVisibleIndex = i;
            lastVisibleRect = childRect;
        }
    }
    if (lastVisibleIndex !== null)
        edges.push([viewport.children[lastVisibleIndex], lastVisibleIndex, lastVisibleRect]);
    return edges;
}
